import { render } from "./UserObject.vue?vue&type=template&id=5cc3734a&scoped=true"
import script from "./UserObject.vue?vue&type=script&lang=js"
export * from "./UserObject.vue?vue&type=script&lang=js"

import "./UserObject.vue?vue&type=style&index=0&id=5cc3734a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc3734a"]])

export default __exports__